// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"f4567ec8","304":"8238425e","430":"fdbbbceb","453":"8f851e24","630":"786ac279","700":"f36ce30b","926":"20bc4bcc","989":"b7d69da7"}[chunkId] + ".chunk.js";
};